module.exports = __webpack_public_path__ + "img/sea.73599b70.png";